import React, { Component } from 'react';

import './EditArea.css';

import Button from './Button.js';


class EditArea extends Component {

  constructor(props){
    super(props);

    this.viewBox = this.props.viewBox;
    this.dX = this.viewBox.split(' ')[2];
    this.dY = this.viewBox.split(' ')[3];
    this.closeInfo = this.closeInfo.bind(this);
    this.addNewSVG = this.addNewSVG.bind(this);
    this.addNewPoint = this.addNewPoint.bind(this);
    this.cleanArea = this.cleanArea.bind(this);
    this.saveArea = this.saveArea.bind(this);

    this.handleOptionChange = this.handleOptionChange.bind(this);



    this.state = ({
      value:0,
      newArea: {
        title:'',
        text:'',
      },
      chosenObjectId:null
    })

  }

  componentDidUpdate(props, state){

    if(this.pageHeight === document.body.offsetHeight){
      return false;
    }

    let _areaWrapper = document.getElementById('area');

    setTimeout(function () {
      this.wrapperWidth = _areaWrapper.offsetWidth;
      this.pageWidth = document.body.offsetWidth;
      this.wrapperHeight = _areaWrapper.offsetHeight;
      this.pageHeight = document.body.offsetHeight;

      let _areaData = _areaWrapper.getBoundingClientRect();

      this.diffX = _areaData.x + window.scrollX;
      this.diffY = _areaData.y + window.scrollY;

    }.bind(this), 500);

  }

  _onMouseMove(e) {

    let _x = ( e.pageX - this.diffX );
    let _y = ( e.pageY - this.diffY );

    _x = _x * (this.dX/this.wrapperWidth);
    _y = _y * (this.dY/this.wrapperHeight);

    const firstDot = this.props.dots[0];
    this.firstDot = null;

    if ( firstDot !== undefined ){

      this.firstDot = document.getElementById('dot-0');

      if( (( _x - firstDot.x < 20 ) && (firstDot.x - _x < 20)) &&
          (( _y - firstDot.y < 20 ) && (firstDot.y - _y < 20)) )
      {
        this.firstDot.classList.add('hover')
      }
      else {
        this.firstDot.classList.remove('hover')
      }
    }

    this.props.onMouseMove(_x, _y);
  }

  closeInfo(){
    this.setState({
      hoverId: false
    })
  }

  addNewSVG(){
    this.props.onNewSvg();
  }

  addNewPoint(){

    if(this.props.zoom > 1){
      alert('Du kan inte lägga till nya ytor när du är inzoomad');
      return false;
    }

    this.newPoints = this.props.points;
    this.newDots = this.props.dots;
    this.newPoints = (this.newPoints !== null) ? this.newPoints : '';

    if(this.firstDot){
      if( this.firstDot.classList.contains('hover')) {
        this.props.triggerPanel(true);

        return false;
      }
    }

    this.newPoints += this.props.mouse.x + ',' + this.props.mouse.y + ' ';

    // if(this.props.zoom > 1){
    //   this.newPoints += (this.props.mouse.x / this.props.zoom) + ',' + (this.props.mouse.y / this.props.zoom) + ' ';
    // }

    // var splittedPoints = this.newPoints.split(',');
    var newDot = {};

    newDot.x = this.props.mouse.x;
    newDot.y = this.props.mouse.y;
    this.newDots.push(newDot);

    this.props.onAddPoint(this.newPoints, this.newDots);
  }

  saveArea(_title, _text){

    if(this.state.chosenObjectId){

      this.svgAreas = this.props.svgAreas;
      if( !this.svgAreas[this.state.chosenObjectId].points ){
        this.svgAreas[this.state.chosenObjectId].points = {};
      }
      this.svgAreas[this.state.chosenObjectId].points[this.props.activeImgId] = this.props.points;

      console.log('save this svgarea: ', this.svgAreas, this.props.points);
      this.props.onSave(this.svgAreas);

      this.props.onNewSvg();
      this.props.triggerPanel(false);

      this.setState({
        chosenObjectId: null
      })
    }
    else {
      alert('Du måste välja vilket objekt som ska kopplas till ytan');
      return false;
    }
  }

  cleanArea(){
    this.props.onClean();
    this.props.triggerPanel(false);
  }

  handleOptionChange(e){
    let val = e.target.value;

    if(val === "null"){
      val = null;
    }

    this.setState({
      chosenObjectId: val
    })

  }


  render() {
    // console.log('EDITAREA RENDER, points: ', this.props.points);
    // console.log('EDITAREA RENDER, activeImgId: ', this.props.activeImgId);
    let currentPoints = (this.props.points) ? this.props.points[this.props.activeImgId] : null;
    let isDisabled = true;

    if( this.props.points ){
      isDisabled = ( this.props.points[this.props.activeImgId] ) ? true : false;
    }

    return (
      <div onMouseMove={this._onMouseMove.bind(this)}>
        <div  className={ (this.props.toggle) ? "new-area editable": "new-area hidden"} >
          <svg version="3.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" onClick={this.addNewPoint}
             viewBox={this.viewBox}>
              <polygon id={this.props.svgId} points={ currentPoints } />
              <div className="icon icon-close" onClick={this.props.onNewSvg}></div>

              {
                this.props.dots.map((dot, index)=>(
                  <circle key={'circle-'+index} id={"dot-"+(index)} className="dot" cx={dot.x} cy={dot.y} r="4"/>
                ))
              }
          </svg>
          <div className={ (this.props.panelOpen) ? "panel active": "panel"}>
            <div className="icon-close" onClick={this.props.onNewSvg}></div>

            <div className={ (this.props.panelOpen) ? "": "hidden"}>
              <div className="select-wrapper">
                <select onChange={this.handleOptionChange}>
                  <option value="null">Välj objekt</option>

                {
                  Object.keys(this.props.data.items).map((object, key)=> {
                    let _availability = false;
                    if( this.props.data.items[object].points ){
                      _availability = this.props.data.items[object].points[this.props.activeImgId] ? true : false;
                    }

                    return (
                      <option key={object} value={object} selected={(this.state.chosenObjectId === object)} disabled={_availability}>
                        {this.props.data.items[object].title}
                      </option>
                    )

                  })
                }
                </select>
              </div>
              <div className="flex-row">
                <Button
                  onClick={this.saveArea}
                  text="Spara"
                />
                <Button
                  onClick={this.cleanArea}
                  text="Rensa"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="edit-panel">
          <Button
            onClick={this.addNewSVG}
            text="Lägg till"
          />
        </div>

      </div>
    );
  }
}

export default EditArea;



// WEBPACK FOOTER //
// ./src/EditArea.js